//请自行添加语言资源
const systemLog = {
  userNo: '用户编码',
  ipAddress: 'IP地址',
  userName: '用户名称',
  title: '标题',
  businessType: '业务类型',
  method: '方法名',
  requestMethod: '请求方式',
  requestUrl: '请求地址',
  responseTime: '响应时间',
  requestParam: '请求参数',
  responseResult: '返回结果',
  operateStatus: '操作状态',
  errorMsg: '错误消息',
  createTime: '创建时间',
  msg: {}
};
export default systemLog



// WEBPACK FOOTER //
// ./src/page/log/systemLog/lang/systemLog.zh.js